import { useEffect, useState, useCallback, useMemo } from 'react';
import Header from '../../Common/Header/Header';
import SuccessPopup from '../../Common/MessagePopup/SuccessPopup';
import FailurePopup from '../../Common/MessagePopup/FailurePopup';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import DatePicker from 'react-datepicker';
import { ChallengeDropDownDataType, SpellingBeeDataType, TableChallengeDataType } from './ChallengeInterface';
import { checkCongratulationData, createCongratsData, createQuestion, DeletAllChallengesByUnitId, deleteQuestionByQuestionId, GetAllChallenges, GetAllChallengesUnits, getChallengeUnitList, updateCongratsData, updateQuestion } from '../../../api/question';
import { getNewAccessToken } from '../../../api/auth';
import { setToken } from '../../../reducers/UserSplice';
import { IdAndName, LoadingDataType, MessageDataType } from '../../Common/Common/CommonInterface';
import { Action, QuestionCategory, QuestionType } from '../Unit-Intro/QuestionEnum';
import { getAllUnitByOffset, getAllUnitWithoutOffset, getUnitByUnitId, searchUnit } from '../../../api/unit';
import { Tooltip } from "react-tooltip";
import Loader from '../../Common/FullscreenLoader/FullScreenLoader';
import { Form } from 'react-bootstrap';
import CustomAlert from '../../Common/MessagePopup/CustomeAlert';
import ConfirmationPopup from '../../Common/MessagePopup/ConfirmationPopup';
import { getGrade } from '../../../api/tribe';
import LottieAnimation from '../../Common/LottieAnimation/LottieAnimation';
import ReactQuill from 'react-quill';
import React from 'react';

const SpellingBee = () => {
    const dispatch = useAppDispatch();
    const { access_token, refresh_token } = useAppSelector((state) => state.user.token);
    const [viewAllChallenges, setViewAllChallenges] = useState<boolean>(false);

    const [validated, setValidated] = useState<boolean>(false);
    const [tableChallengeData, setTableChallengeData] = useState<TableChallengeDataType[]>([]);
    const [tableData, setTableData] = useState<TableChallengeDataType>({
        id: "",
        unit: { id: "", name: "" },
        lesson: { id: "", name: "" },
        grade: { gradeId: "", gradeName: "" },
        subject: { id: "", name: "" },
        tribe: { id: "", name: "" },
        status: "",
    });
    const [activeFilter, setActiveFilter] = useState<{ status: string, grade: IdAndName }>({
        status: "",
        grade: { id: "", name: "" },
    })
    const [filter, setFilter] = useState<{ status: string, dateFilter: string, grade: string }>({ status: "", dateFilter: "", grade: "" })
    const [dropDownList, setDropDownList] = useState<{ grade: IdAndName[] }>({
        grade: []
    })
    //Challenges Variables
    const [allChallengeData, setAllChallengeData] = useState<SpellingBeeDataType[]>([]);

    const [showCongratulationsField, setShowCongratulationsField] = useState<boolean>(false);

    const [dropdownList, setDropdownList] = useState<ChallengeDropDownDataType>({
        dropdownLevel: 0,
        dropdownUnit: [],
    })
    const [editSpellingBeeChallengeData, setEditSpellingBeeChallengeData] = useState<SpellingBeeDataType>({
        id: "",
        unit: { id: "", name: "" },
        grade: { gradeId: "", gradeName: "" },
        deletedOption: [],
        deleteS3Path: [],
        question: "",
        challengeMedia: {
            audioFile: { files: "", blobPath: "", fileExtension: "" }
        },
        spellingBee: {
            SpellingBeeText: "",
            MediaFile: {
                videoFile: { files: "", blobPath: "", fileExtension: "" }
            },
            reward: 0
        },
        congratulation: {
            congratulationId: "",
            congratulationBadgeIcon: {
                files: "",
                blobPath: "",
                fileExtension: ""

            },
            congratulationAudio: {
                files: "",
                blobPath: "",
                fileExtension: ""

            },
            congratulationText: "",
            congratulationCoins: 0,
            deletedS3Path: []
        }
    })
    const [addChallenges, setAddChallenges] = useState<boolean>(false);
    const [show, setShow] = useState(false);
    const [confirmationPopupData, setConfirmationPopupData] = useState({
        title: '',
        message: '',
        descriptions: '',
        acceptText: '',
        cancelText: '',
        onAccept: () => { },
        onCancel: () => { },
    });
    const [loading, setLoading] = useState<LoadingDataType>({
        fetchingLoading: false,
        tableLoading: false,
        deleteLoading: false,
        submitLoading: false,
        viewLoading: false,
        validationLoading: false,
    });
    const [message, setMessage] = useState<MessageDataType>({
        errorMessage: [],
        successMessage: '',
        failureMessage: '',
    });

    useEffect(() => {
        if (message.errorMessage.length > 0) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }

    }, [message.errorMessage.length])


    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const [challengeCount, setChallengeCount] = useState<number>(0);
    const [startDate, setStartDate] = useState<Date | null>(null);
    const [endDate, setEndDate] = useState<Date | null>(null);
    const [searchtext, setSearchText] = useState<string>('');

    const indexOfLastItem = useMemo(() => currentPage * itemsPerPage, [currentPage, itemsPerPage]);
    const indexOfFirstItem = useMemo(() => indexOfLastItem - itemsPerPage, [indexOfLastItem, itemsPerPage]);

    const [isAnimationFullscreen, setIsAnimationFullscreen] = useState<boolean>(false)
    const [previewSource, setPreviewSource] = useState<string | null>(null);
    const [previewSourceType, setPreviewSourceType] = useState<string | null>(null);

    const handleClose = useCallback(() => setShow(false), []);

    const handleTableChallengeData = useCallback((challengeData: any) => {
        try {
            const { units, count } = challengeData;
            setChallengeCount(count);

            const formattedData: TableChallengeDataType[] = units.map((unit: any) => {
                return {
                    id: unit.id,
                    unit: { id: unit.id, name: unit.name },
                    lesson: { id: unit.lesson.id, name: unit.lesson.name },
                    grade: { gradeId: unit.lesson.grade_id.id, gradeName: unit.lesson.grade_id.name },
                    subject: { id: unit.lesson.subject_id.id, name: unit.lesson.subject_id.name },
                    tribe: { id: unit.lesson.tribe_id.id, name: unit.lesson.tribe_id.name },
                    status: unit.isActive === 1 ? "PUBLISHED" : (unit.isActive === 2 ? "DRAFT" : "UNPUBLISHED"),
                };
            });
            setTableChallengeData(formattedData);
        } catch (error) {
            console.error('Handle Challenge Data Error:', error);
        } finally {
            setLoading((prevLoading) => ({ ...prevLoading, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, viewLoading: false, validationLoading: false }));
        }
    }, []);



    const handleClosePreview = () => {
        setPreviewSourceType(null)
        setPreviewSource(null);
    };

    const getAuthorizedToken = useCallback(async () => {
        try {
            const newTokenResponse = await getNewAccessToken({ refreshToken: refresh_token });
            const { data, statusCode } = newTokenResponse;
            if (statusCode === 200) {
                dispatch(setToken({
                    access_token: data.accessToken,
                    refresh_token: data.refreshToken,
                }));
            }
        } catch (error: any) {
            console.error('Something went wrong in getting new access Token :: ', error);
        }
    }, [dispatch, refresh_token]);

    const getAllChallenges = useCallback(async (offset: number) => {

        setChallengeCount(0);
        setLoading((prevLoading) => ({ ...prevLoading, fetchingLoading: false, tableLoading: true, deleteLoading: false, submitLoading: false, viewLoading: false, validationLoading: false }));
        try {
            const challengeResponse = await searchUnit(searchtext, activeFilter.status, activeFilter.grade.id, (startDate && endDate) ? formatLocalDate(startDate) : null, (startDate && endDate) ? formatLocalDate(endDate) : null, String(indexOfFirstItem), String(indexOfLastItem), QuestionCategory.spellingbee, access_token)
            const { data, statusCode } = challengeResponse;
            if (statusCode === 200) {
                handleTableChallengeData(data);
            } else if (statusCode === 401) {
                getAuthorizedToken();
                setMessage((prevMessage: MessageDataType) => ({
                    ...prevMessage,
                    failureMessage: 'Authorization token expired. Try again!',
                }));
            }
        } catch (error) {
            console.error('Get All Challenges Error:', error);
        }


    }, [access_token, getAuthorizedToken, handleTableChallengeData, currentPage]);

    const resetEditChallengeObject = () => {
        setEditSpellingBeeChallengeData({
            ...editSpellingBeeChallengeData,
            id: "",
            deletedOption: [],
            deleteS3Path: [],
            question: "",
            challengeMedia: {
                audioFile: { files: "", blobPath: "", fileExtension: "" }
            },
            spellingBee: {
                SpellingBeeText: "",
                MediaFile: {
                    videoFile: { files: "", blobPath: "", fileExtension: "" }
                },
                reward: 0
            }
        })
    }


    function removeSpans(html: string): string {
        // Remove opening span tags with attributes
        let cleaned = html.replace(/<span[^>]*>/g, "");
        // Remove closing span tags
        cleaned = cleaned.replace(/<\/span>/g, "");
        return cleaned;
    }

    const handleCongratsInput = (e: React.ChangeEvent<HTMLInputElement> | null, name: string, value: string, isReplace: boolean) => {
        if (e) {
            const { files } = e.target;
            if (name === "congratulations-audio" || name === "congratulations-badge") {

                if (!files || files.length === 0) return;

                const file = files[0];

                if (file && (file.name.toLowerCase().endsWith('.mp3') || file.name.toLowerCase().endsWith('.wav'))) {
                    setEditSpellingBeeChallengeData((prevData) => {
                        const updatedCongrats = { ...prevData.congratulation };
                        if (isReplace) {
                            if (!(updatedCongrats.congratulationAudio.files instanceof File)) {
                                updatedCongrats.deletedS3Path = [
                                    ...updatedCongrats.deletedS3Path,
                                    updatedCongrats.congratulationAudio.files.replace(
                                        `${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}`,
                                        ""
                                    ),
                                ];
                            }

                        }

                        updatedCongrats.congratulationAudio = {
                            files: file,
                            blobPath: URL.createObjectURL(file),
                            fileExtension: file.name.toLowerCase().split(".").pop() || "",
                        }

                        return {
                            ...prevData,
                            congratulation: updatedCongrats,
                        };
                    });
                } else {
                    setMessage({
                        ...message,
                        errorMessage: ['Unsupported image format. Please upload MP3 or WAV files.']
                    });
                    return;
                }
                // else if (file && (file.name.toLowerCase().endsWith('.png') || file.name.toLowerCase().endsWith('.jpg') || file.name.toLowerCase().endsWith('.jpeg') || file.name.toLowerCase().endsWith('.svg'))) {
                //     setEditSpellingBeeChallengeData((prevData) => {
                //         const updatedCongrats = { ...prevData.congratulation };
                //         if (isReplace) {
                //             updatedCongrats.deletedS3Path = [...updatedCongrats.deletedS3Path, updatedCongrats.congratulationBadgeIcon.blobPath];
                //         }
                //         updatedCongrats.congratulationBadgeIcon = {
                //             files: file,
                //             blobPath: URL.createObjectURL(file),
                //             fileExtension: file.name.toLowerCase().split(".").pop() || "",
                //         }

                //         return {
                //             ...prevData,
                //             congratulation: updatedCongrats,
                //         };
                //     });
                // } 
                // else if (file && (file.name.toLowerCase().endsWith('.json'))) {

                //     const reader = new FileReader();
                //     reader.onload = (event) => {
                //         try {
                //             const json = JSON.parse(event.target?.result as string);
                //             if (!isLottieJson(json)) {
                //                 setMessage({
                //                     ...message,
                //                     errorMessage: ['Uploaded JSON is not a valid Lottie JSON animation.']
                //                 });
                //                 return;
                //             }

                //             // Proceed to set state if valid
                //             // setEditSpellingBeeChallengeData((prevData) => {
                //             //     const updatedCongrats = { ...prevData.congratulation };
                //             //     if (isReplace) {
                //             //         updatedCongrats.deletedS3Path = [...updatedCongrats.deletedS3Path, updatedCongrats.congratulationBadgeIcon.blobPath];
                //             //     }
                //             //     updatedCongrats.congratulationBadgeIcon = {
                //             //         files: file,
                //             //         blobPath: URL.createObjectURL(file),
                //             //         fileExtension: file.name.toLowerCase().split(".").pop() || "",
                //             //     }

                //             //     return {
                //             //         ...prevData,
                //             //         congratulation: updatedCongrats,
                //             //     };
                //             // });
                //         } catch (err) {
                //             setMessage({
                //                 ...message,
                //                 errorMessage: ['Failed to parse JSON file.']
                //             });
                //         }
                //     };
                //     reader.readAsText(file);
                //     return;

                // } else {
                //     setMessage({
                //         ...message,
                //         errorMessage: ['Unsupported image format. Please upload PNG, JPG, JPEG or SVG files.']
                //     });
                //     return;
                // }
            } else if (name === "congratulation-coins") {
                setEditSpellingBeeChallengeData((prevData) => ({
                    ...prevData,
                    congratulation: {
                        ...prevData.congratulation,
                        congratulationCoins: Number(value)
                    }
                }))
            }
        } else {
            if (name === "congratulation-text") {
                setEditSpellingBeeChallengeData((prevData) => ({
                    ...prevData,
                    congratulation: {
                        ...prevData.congratulation,
                        congratulationText: removeSpans(value)
                    }
                }))
            }
        }


    }


    const validateCongratsData = () => {
        let errorMessage: string[] = [];
        const isMediaValid = (media: any) => media && media.files;
        const { congratulation } = editSpellingBeeChallengeData;

        // if (congratulation.congratulationCoins <= 0) errorMessage.push("Coins should be greater than 0");
        if (!congratulation.congratulationText || congratulation.congratulationText.replace(/<[^>]*>/g, "").trim() === "") errorMessage.push("Please enter a valid congratulation text");
        // if (!isMediaValid(congratulation.congratulationBadgeIcon)) errorMessage.push("Please upload a valid badge icon");
        if (!isMediaValid(congratulation.congratulationAudio)) errorMessage.push("Please upload a valid congratulation audio");
        if (errorMessage.length > 0) {
            setMessage({
                ...message,
                errorMessage: errorMessage,
            });
            return false;
        } else {
            handleSubmitCongratsData();
        }

    }

    const handleSubmitCongratsData = async () => {
        setLoading((prevLoading) => ({ ...prevLoading, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: true, viewLoading: false, validationLoading: false }));
        try {
            const formdata = new FormData();
            if (editSpellingBeeChallengeData.congratulation.congratulationId)
                formdata.append("id", editSpellingBeeChallengeData.congratulation.congratulationId)
            formdata.append("difficulty_level_id", "4");
            formdata.append("grade_id", editSpellingBeeChallengeData.grade.gradeId);
            formdata.append("unit_id", editSpellingBeeChallengeData.unit.id);
            formdata.append("text", editSpellingBeeChallengeData.congratulation.congratulationText);
            // formdata.append("reward", editSpellingBeeChallengeData.congratulation.congratulationCoins.toString());
            formdata.append("challenge_type", "SPELLINGBEE");
            // if (editSpellingBeeChallengeData.congratulation.congratulationBadgeIcon.files instanceof File) {
            //     formdata.append("image_path", editSpellingBeeChallengeData.congratulation.congratulationBadgeIcon.files);
            // }

            if (editSpellingBeeChallengeData.congratulation.congratulationAudio.files instanceof File) {
                formdata.append("audio_file_path", editSpellingBeeChallengeData.congratulation.congratulationAudio.files);
            }

            if (editSpellingBeeChallengeData.congratulation.deletedS3Path.length > 0) {
                formdata.append("removeFiles", JSON.stringify(editSpellingBeeChallengeData.congratulation.deletedS3Path.filter((s3path: string) => s3path.trim() !== "").map((s3path: string) => ({ path: s3path.replace(`${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}`, "") }))));
            }

            const getFileExtension = (path: string) => path ? path.split('.').pop() : "";

            const getMediaObject = (path: string) => ({
                files: `${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}${path}` || "",
                blobPath: `${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}${path}` || "",
                fileExtension: getFileExtension(path),
            });
            if (editSpellingBeeChallengeData.congratulation.congratulationId) {
                await updateCongratsData(formdata, access_token).then((updateResponse) => {
                    const { data, statusCode } = updateResponse;
                    if (statusCode === 200) {

                        setEditSpellingBeeChallengeData((prevData) => ({
                            ...prevData,
                            congratulation: {
                                congratulationId: data.id,
                                // congratulationBadgeIcon: getMediaObject(data[0].image_path),
                                congratulationAudio: getMediaObject(data.audio_file_path),
                                congratulationText: data.text,
                                congratulationCoins: data.reward,
                                deletedS3Path: []
                            }
                        }));
                        setMessage({
                            ...message,
                            successMessage: "Congratulations updated successfully!"
                        });
                    } else if (statusCode === 401) {
                        getAuthorizedToken();
                        setMessage({
                            ...message,
                            failureMessage: "Authorization token expired. Try again!"
                        })
                    }

                });
            } else {
                await createCongratsData(formdata, access_token).then((createResponse) => {
                    const { data, statusCode } = createResponse;
                    if (statusCode === 200) {
                        setEditSpellingBeeChallengeData((prevData) => ({
                            ...prevData,
                            congratulation: {
                                congratulationId: data.id,
                                congratulationBadgeIcon: getMediaObject(data.image_path),
                                congratulationAudio: getMediaObject(data.audio_file_path),
                                congratulationText: data.text,
                                congratulationCoins: data.reward,
                                deletedS3Path: []
                            }
                        }));
                        setMessage({
                            ...message,
                            successMessage: "Congratulations added successfully!"
                        });
                    } else if (statusCode === 401) {
                        getAuthorizedToken();
                        setMessage({
                            ...message,
                            failureMessage: "Authorization token expired. Try again!"
                        })
                    }
                });
            }
        } catch (error: any) {
            if (error.response && error.response.data && typeof error.response.data === "string") {
                setMessage({
                    ...message,
                    failureMessage: error.response.data.message
                })
            } else {
                setMessage({
                    ...message,
                    failureMessage: "Something went wrong. Please try again"
                })
            }
        } finally {
            setTimeout(() => {
                setMessage(((prev: MessageDataType) => {
                    const updatedData = { ...prev };
                    updatedData.errorMessage = prev.errorMessage;
                    updatedData.failureMessage = "";
                    updatedData.successMessage = ""
                    return updatedData
                }))

            }, 2500)
            setLoading((prevLoading) => ({ ...prevLoading, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, viewLoading: false, validationLoading: false }));
        }

    }

    const handleFilter = (name: string, value: string | IdAndName) => {
        if (name === "status" && typeof value === "string") {
            setActiveFilter(prev => ({
                ...prev,
                status: value ? value : ""
            }));

            setFilter(prev => ({
                ...prev,
                status: value === "1" ? "Published" : value === "2" ? "Draft" : value === "0" ? "Unpublished" : ""
            }));
        } else if (name === "grade" && typeof value === "object") {
            setActiveFilter(prev => ({
                ...prev,
                grade: value
            }));

            setFilter(prev => ({
                ...prev,
                grade: value.name
            }));
        } else if (name === "date") {
            setFilter({
                ...filter,
                dateFilter: ""
            })
            setStartDate(null)
            setEndDate(null)
        }
    };

    useEffect(() => {
        if (!viewAllChallenges) {
            getAllChallenges(indexOfFirstItem);
            getAllGrade();
            setTableData({
                id: "",
                unit: { id: "", name: "" },
                lesson: { id: "", name: "" },
                grade: { gradeId: "", gradeName: "" },
                subject: { id: "", name: "" },
                tribe: { id: "", name: "" },
                status: "",
            });
        }
    }, [getAllChallenges, indexOfFirstItem, itemsPerPage, viewAllChallenges]);


    const handleSpellingBeeValidation = () => {
        const { unit, spellingBee, congratulation } = editSpellingBeeChallengeData;
        let errorList = [];

        if (!viewAllChallenges) {
            if (!unit.id) {
                errorList.push("Select the valid unit");
            }

            if (showCongratulationsField) {
                if (!congratulation.congratulationText.replace(/<[^>]*>/g, '').trim()) {
                    errorList.push(`Congratulations Text is required.`);
                }

                if (!congratulation.congratulationAudio.files) {
                    errorList.push("Upload the valid congratulations VO.")
                }
            }
        }


        if (!spellingBee.SpellingBeeText.trim()) {
            errorList.push("Input valid spelling bee text.")
        }

        if (spellingBee.reward <= 0) {
            errorList.push("Reward should be greater than 0")
        }

        // if (!spellingBee.MediaFile.videoFile.files) {
        //     errorList.push("Upload valid spelling bee intro video file")
        // }

        if (errorList.length > 0) {
            setMessage({
                ...message,
                errorMessage: errorList
            })
        } else {
            handleSubmit()
        }
    }

    const handleSubmit = async () => {
        setLoading((prevLoading) => ({ ...prevLoading, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: true, viewLoading: false, validationLoading: false }));

        const buildChallengeFormData = () => {
            const fd = new FormData();
            const { spellingBee, challengeMedia, grade, unit } = editSpellingBeeChallengeData;

            if (editSpellingBeeChallengeData.id) {
                fd.append("id", editSpellingBeeChallengeData.id);
            }

            fd.append("difficulty_level_Id", "4");
            fd.append("grade_id", grade.gradeId);
            fd.append("unit_id", unit.id);
            fd.append("level", "1");
            fd.append("category", QuestionCategory.spellingbee);
            fd.append("type", "NONE");
            fd.append("action", "NONE");
            fd.append("question", spellingBee.SpellingBeeText);
            fd.append("reward", String(spellingBee.reward));

            // Animation
            const videoFile = spellingBee.MediaFile.videoFile.files;
            if (videoFile instanceof File) {
                fd.append("animation_file", videoFile);
                fd.append("animation_exist", "true");
            } else {
                fd.append("animation_exist", "false");
            }

            // Audio
            const audioFile = challengeMedia.audioFile.files;
            if (audioFile instanceof File) {
                fd.append("audio_file_path", audioFile);
                fd.append("audio_exist", "true");
            } else {
                fd.append("audio_exist", "false");
            }

            return fd;
        };

        const buildCongratsFormData = () => {
            const fd = new FormData();
            const { congratulation, grade, unit } = editSpellingBeeChallengeData;

            fd.append("difficulty_level_id", "4");
            fd.append("grade_id", grade.gradeId);
            fd.append("unit_id", unit.id);
            fd.append("text", congratulation.congratulationText);
            fd.append("challenge_type", "SPELLINGBEE");

            const audioFile = congratulation.congratulationAudio.files;
            if (audioFile instanceof File) {
                fd.append("audio_file_path", audioFile);
            }

            return fd;
        };

        try {
            if (editSpellingBeeChallengeData.id) {
                // 🔹 Update Challenge
                const formData = buildChallengeFormData();
                const updateChallengeResponse = await updateQuestion(formData, access_token);
                const { data, statusCode } = updateChallengeResponse;

                if (statusCode === 200) {
                    setMessage({ ...message, successMessage: "Challenge updated successfully!" });
                } else if (statusCode === 401) {
                    getAuthorizedToken();
                    setMessage({ ...message, failureMessage: "Authorization token expired. Try again!" });
                }
            } else {
                // 🔹 Create Challenge (with optional Congratulations)
                if (!viewAllChallenges && showCongratulationsField) {
                    const congratsFormData = buildCongratsFormData();
                    const createCongratsRes = await createCongratsData(congratsFormData, access_token);

                    if (createCongratsRes.statusCode === 200) {
                        setMessage({ ...message, successMessage: "Karaoke Video created successfully!" });
                        setEditSpellingBeeChallengeData(prev => ({
                            ...prev,
                            congratulation: {
                                ...prev.congratulation,
                                congratulationId: createCongratsRes.data.id,
                                congratulationText: createCongratsRes.data.text,
                                congratulationAudio: createCongratsRes.data.audio_file_path
                            }
                        }));
                    }
                }

                const formData = buildChallengeFormData();
                const createChallengeResponse = await createQuestion(formData, access_token);
                const { data, statusCode } = createChallengeResponse;

                if (statusCode === 200) {
                    setMessage({ ...message, successMessage: "Challenge added successfully!" });
                } else if (statusCode === 401) {
                    getAuthorizedToken();
                    setMessage({ ...message, failureMessage: "Authorization token expired. Try again!" });
                }
            }
        } catch (error: any) {
            if (error.response?.data && typeof error.response.data === "string") {
                setMessage({ ...message, failureMessage: error.response.data.message });
            } else {
                setMessage({ ...message, failureMessage: "Something went wrong. Please try again" });
            }
        } finally {
            resetEditChallengeObject?.(); // Only exists on update
            setAddChallenges(false);
            setLoading((prevLoading) => ({ ...prevLoading, fetchingLoading: false, tableLoading: true, deleteLoading: false, submitLoading: false, viewLoading: true, validationLoading: false }));
            viewAllQuestion(editSpellingBeeChallengeData.unit.id);

            setTimeout(() => {
                setMessage({ ...message, failureMessage: "", successMessage: "" });
            }, 2500);
        }
    };


    const handleCancel = async () => {
        setShow(true)
        setConfirmationPopupData({
            title: `Are you sure you want to cancel?`,
            message: "This action cannot be undone.",
            descriptions: "",
            acceptText: "Yes",
            cancelText: "Cancel",
            onAccept: async () => {
                setShow(false);
                setAddChallenges(false);
                if (viewAllChallenges) {
                    setEditSpellingBeeChallengeData({
                        ...editSpellingBeeChallengeData,
                        id: "",
                        deletedOption: [],
                        deleteS3Path: [],
                        question: "",
                        challengeMedia: {
                            audioFile: { files: "", blobPath: "", fileExtension: "" }
                        },
                        spellingBee: {
                            SpellingBeeText: "",
                            MediaFile: {
                                videoFile: { files: "", blobPath: "", fileExtension: "" }
                            },
                            reward: 0
                        },
                    })
                    setCurrentPage(1);
                    viewAllQuestion(editSpellingBeeChallengeData.unit.id);
                } else {
                    setCurrentPage(1)
                    getAllChallenges(indexOfFirstItem);
                    setEditSpellingBeeChallengeData({
                        ...editSpellingBeeChallengeData,
                        id: "",
                        deletedOption: [],
                        deleteS3Path: [],
                        question: "",
                        challengeMedia: {
                            audioFile: { files: "", blobPath: "", fileExtension: "" }
                        },
                        spellingBee: {
                            SpellingBeeText: "",
                            MediaFile: {
                                videoFile: { files: "", blobPath: "", fileExtension: "" }
                            },
                            reward: 0
                        },
                    })
                }


            },
            onCancel: handleClose,
        })

    }

    useEffect(() => {
        if (!addChallenges) {
            resetEditChallengeObject();
            setCurrentPage(1)
            getAllChallenges(indexOfFirstItem);
        }
    }, [addChallenges])


    const handlePagination = useCallback(async (pageNumber: number, direction: string) => {
        if (pageNumber < 1 || pageNumber > Math.ceil(challengeCount / itemsPerPage)) {
            return; // Prevent navigation to invalid pages
        }

        try {
            setLoading((prevLoading) => ({ ...prevLoading, fetchingLoading: false, tableLoading: true, deleteLoading: false, submitLoading: false, viewLoading: false, validationLoading: false }));
            if (direction === 'right' && pageNumber <= Math.ceil(challengeCount / itemsPerPage)) {
                setCurrentPage(pageNumber);
            } else if (direction === 'left' && pageNumber >= 1) {
                setCurrentPage(pageNumber);
            }
        } finally {
            setLoading((prevLoading) => ({ ...prevLoading, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, viewLoading: false, validationLoading: false }));
        }
    }, [challengeCount, itemsPerPage]);

    const handleChallengeData = (challengeData: any) => {
        try {
            setLoading((prevLoading) => ({ ...prevLoading, fetchingLoading: false, tableLoading: true, deleteLoading: false, submitLoading: false, viewLoading: false, validationLoading: false }));
            const { congratulationData, questionData, count } = challengeData;
            setChallengeCount(count);
            const getFileExtension = (path: string) => path ? path.split('.').pop() : "";

            const getMediaObject = (path: string) => ({
                files: path ? `${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}${path}` : "",
                blobPath: path ? `${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}${path}` : "",
                fileExtension: getFileExtension(path),
            });

            const congratulation = congratulationData
                ? {
                    congratulationId: congratulationData.id,
                    congratulationBadgeIcon: getMediaObject(congratulationData.image_path),
                    congratulationAudio: getMediaObject(congratulationData.audio_file_path),
                    congratulationText: congratulationData.text,
                    congratulationCoins: congratulationData.reward,
                    deletedS3Path: []
                }
                : {
                    congratulationId: "",
                    congratulationBadgeIcon: getMediaObject(""),
                    congratulationAudio: getMediaObject(""),
                    congratulationText: "",
                    congratulationCoins: 0,
                    deletedS3Path: []
                };
            const formattedData: SpellingBeeDataType[] = questionData.map((question: any) => ({
                id: question.id,
                deletedOption: [],
                deleteS3Path: [],
                category: QuestionCategory.spellingbee,
                question: question.question,
                challengeMedia: {
                    audioFile: getMediaObject(question.audio_file_path ? question.audio_file_path : "")
                },
                spellingBee: {
                    SpellingBeeText: question.question,
                    MediaFile: {
                        videoFile: getMediaObject(question.animation_file_path ? question.animation_file_path : "")
                    },
                    reward: question.reward ? Number(question.reward) : 0
                },
            }));

            setAllChallengeData(formattedData)
            setEditSpellingBeeChallengeData((prev) => ({
                ...prev,
                congratulation: congratulation
            }));
        } catch (error: any) {
            if (error.response && error.response.data && typeof error.response.data === "string") {
                setMessage({
                    ...message,
                    failureMessage: error.response.data.message
                })
            } else {
                setMessage({
                    ...message,
                    failureMessage: "Something went wrong. Please try again"
                })
            }
        } finally {
            setLoading((prevLoading) => ({ ...prevLoading, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, viewLoading: false, validationLoading: false }));
        }
    }


    useEffect(() => {
        const handleSearch = async () => {
            setLoading((prevLoading) => ({ ...prevLoading, fetchingLoading: false, tableLoading: true, deleteLoading: false, submitLoading: false, viewLoading: false, validationLoading: false }));
            setCurrentPage(1);
            if (startDate && endDate) {
                const lang = navigator.language || navigator.languages[0];
                setFilter({
                    ...filter,
                    dateFilter: `${startDate ? startDate.toLocaleDateString(lang, { day: "numeric", month: "short", year: "numeric" }) : ""} - ${endDate ? endDate.toLocaleDateString(lang, { day: "numeric", month: "short", year: "numeric" }) : ""
                        }`
                });
            }
            try {
                const searchTribeData = await searchUnit(searchtext, activeFilter.status, activeFilter.grade.id, (startDate && endDate) ? formatLocalDate(startDate) : null, (startDate && endDate) ? formatLocalDate(endDate) : null, String(indexOfFirstItem), String(indexOfLastItem), QuestionCategory.spellingbee, access_token);

                const { data, statusCode } = searchTribeData;

                if (statusCode === 200) {
                    handleTableChallengeData(data);
                } else if (statusCode === 401) {
                    getAuthorizedToken();
                    setMessage({
                        ...message,
                        failureMessage: "Authorization token expired. Try again!"
                    })
                }
            } catch (error: any) {
                console.error("Search Error ::", error);
                if (error.response && error.response.data && typeof error.response.data === 'string') {
                    setMessage({
                        ...message,
                        failureMessage: error.response.data.message
                    })
                } else {
                    setMessage({
                        ...message,
                        failureMessage: "Something went wrong. Please try again"
                    })
                }
            } finally {
                setTimeout(() => {
                    setMessage(({
                        errorMessage: [],
                        successMessage: "",
                        failureMessage: ""
                    }))
                }, 2500)

                setLoading((prevLoading) => ({ ...prevLoading, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, viewLoading: false, validationLoading: false }));
            }
        }

        handleSearch()

    }, [searchtext, activeFilter.status, activeFilter.grade.id, startDate, endDate])


    const getAllGrade = async () => {
        const gradeResponse = await getGrade();

        setDropDownList({
            grade: gradeResponse.data.data.map((grade: any) => ({
                id: grade.id,
                name: grade.name
            }))
        })

    }

    const formatLocalDate = (date: Date | null): string | null => {
        if (!date) return null; // Handle null case

        const localDate = new Date(date);
        localDate.setMinutes(localDate.getMinutes() - localDate.getTimezoneOffset()); // Adjust for timezone shift

        return localDate.toISOString().split("T")[0]; // Extract YYYY-MM-DD
    };


    const handleDropDownData = async (value: string) => {
        setLoading((prevLoading) => ({ ...prevLoading, fetchingLoading: true, tableLoading: false, deleteLoading: false, submitLoading: false, viewLoading: false, validationLoading: false }));
        try {
            await getUnitByUnitId(value, access_token).then(async (unitResponse) => {
                const { data, statusCode } = unitResponse;

                if (statusCode === 200) {

                    await checkCongratulationData({ difficulty_level_Id: 4, unit_id: data.id, challenge_type: "SPELLINGBEE" }, access_token).then((checkCongratsResponse) => {
                        const { data, statusCode } = checkCongratsResponse;
                        if (statusCode === 200) {
                            if (data) {
                                setShowCongratulationsField(false)
                            } else {
                                setShowCongratulationsField(true)
                            }
                        }

                    })
                    setEditSpellingBeeChallengeData({
                        id: "",
                        unit: { id: data.id, name: data.name },
                        grade: { gradeId: data.lesson.grade_id.id, gradeName: data.lesson.grade_id.name },
                        deletedOption: [],
                        deleteS3Path: [],
                        question: "",
                        challengeMedia: {
                            audioFile: { files: "", blobPath: "", fileExtension: "" }
                        },
                        spellingBee: {
                            SpellingBeeText: "",
                            MediaFile: {
                                videoFile: { files: "", blobPath: "", fileExtension: "" }
                            },
                            reward: 0
                        },
                        congratulation: {
                            congratulationId: "",
                            congratulationBadgeIcon: {
                                files: "",
                                blobPath: "",
                                fileExtension: ""

                            },
                            congratulationAudio: {
                                files: "",
                                blobPath: "",
                                fileExtension: ""

                            },
                            congratulationText: "",
                            congratulationCoins: 0,
                            deletedS3Path: []
                        }
                    });
                    setDropdownList({
                        ...dropdownList,
                        dropdownLevel: data.level
                    })
                }
            })
        } catch (error: any) {
            console.error("ERROR IN UNIT BY NIT ID :: ", error);

        } finally {
            setLoading((prevLoading) => ({ ...prevLoading, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, viewLoading: false, validationLoading: false }));
        }

    }


    const handleInputChange = (value: string, name: string) => {
        if (name === "spellingBee") {
            setEditSpellingBeeChallengeData((prevData: any) => {
                const updatedData: SpellingBeeDataType = { ...prevData };
                updatedData.question = value;
                updatedData.spellingBee.SpellingBeeText = value;

                return { ...updatedData };
            })
        } else if (name === "reward") {
            setEditSpellingBeeChallengeData((prevData: any) => {
                const updatedData: SpellingBeeDataType = { ...prevData };
                updatedData.spellingBee.reward = Number(value);

                return { ...updatedData };
            })
        }


    }

    const handleChallengeMedia = (e: any, label: string, fieldName: string) => {
        if (label === "delete") {
            setShow(true)
            setConfirmationPopupData({
                title: `Are you sure you want to delete?`,
                message: "This action cannot be undone.",
                descriptions: "",
                acceptText: "Delete",
                cancelText: "Cancel",
                onAccept: async () => {
                    setShow(false)
                    setEditSpellingBeeChallengeData((prev: any) => {


                        const updatedData: SpellingBeeDataType = { ...prev }

                        if (fieldName === "audioFile") {
                            updatedData.challengeMedia.audioFile = { files: "", blobPath: "", fileExtension: "" }

                        } else if (fieldName === "videoFile") {
                            updatedData.spellingBee.MediaFile.videoFile = { files: "", blobPath: "", fileExtension: "" }
                        }

                        return updatedData;
                    })
                },
                onCancel: handleClose,
            })
        } else if (label === "add") {
            const { name, files } = e.target;
            setEditSpellingBeeChallengeData((prev: any) => {
                const updatedData: SpellingBeeDataType = { ...prev }


                if (fieldName === "videoFile") {
                    updatedData.spellingBee.MediaFile.videoFile = {
                        files: files[0],
                        blobPath: URL.createObjectURL(files[0]),
                        fileExtension: files[0].name.split('.').pop()
                    }
                } else if (fieldName === "audioFile") {
                    updatedData.challengeMedia.audioFile = {
                        files: files[0],
                        blobPath: URL.createObjectURL(files[0]),
                        fileExtension: files[0].name.split('.').pop()
                    }
                }




                return { ...updatedData };
            })

        }
    }

    const handleEditChallenges = (challengeData: SpellingBeeDataType) => {
        setFilter({
            status: "",
            dateFilter: "",
            grade: ""
        })
        setActiveFilter({
            status: "",
            grade: { id: "", name: "" }
        })
        setStartDate(null)
        setEndDate(null);
        setSearchText("");
        setEditSpellingBeeChallengeData({
            ...editSpellingBeeChallengeData,
            id: challengeData.id,
            deletedOption: [],
            deleteS3Path: [],
            question: challengeData.question,
            challengeMedia: challengeData.challengeMedia,
            spellingBee: challengeData.spellingBee,
        });
    }

    const handleDeleteChallengeById = async (challengeId: string) => {
        setShow(true)
        setConfirmationPopupData({
            title: `Are you sure you want to delete?`,
            message: "This action cannot be undone.",
            descriptions: "",
            acceptText: "Delete",
            cancelText: "Cancel",
            onAccept: async () => {
                setShow(false)
                setLoading((prevLoading) => ({ ...prevLoading, fetchingLoading: false, tableLoading: false, deleteLoading: true, submitLoading: false, viewLoading: false, validationLoading: false }));
                try {
                    await deleteQuestionByQuestionId(challengeId, access_token).then((deleteChallengeResponse) => {
                        const { data, statusCode } = deleteChallengeResponse;

                        if (statusCode === 200) {
                            setMessage({
                                ...message,
                                successMessage: "Challenge deleted successfully!"
                            })
                        } else if (statusCode === 401) {
                            getAuthorizedToken();
                            setMessage((prevMessage: MessageDataType) => ({
                                ...prevMessage,
                                failureMessage: 'Authorization token expired. Try again!',
                            }));
                        }
                    })
                } catch (error: any) {
                    if (error.response && error.response.data && typeof error.response.data === "string") {
                        setMessage({
                            ...message,
                            failureMessage: error.response.data.message
                        })
                    } else {
                        setMessage({
                            ...message,
                            failureMessage: "Something went wrong. Please try again"
                        })
                    }
                } finally {
                    resetEditChallengeObject();
                    setCurrentPage(1);
                    setLoading((prevLoading) => ({ ...prevLoading, fetchingLoading: false, tableLoading: true, deleteLoading: false, submitLoading: false, viewLoading: false, validationLoading: false }));
                    viewAllQuestion(editSpellingBeeChallengeData.unit.id);
                    setTimeout(() => {
                        setMessage({
                            ...message,
                            failureMessage: "",
                            successMessage: ""
                        });
                    }, 2500)
                }
            },
            onCancel: handleClose,
        })

    }

    const handleEndDateChange = (date: any) => {
        const currentDate = new Date(); // Get the current date

        if (!startDate) {
            setMessage({
                ...message,
                errorMessage: [
                    "Please select a start date before choosing the end date.",
                ],
            });
            return;
        }

        if (date < startDate) {
            setMessage({
                ...message,
                errorMessage: [
                    "The end date cannot be earlier than the start date. Please choose a valid end date.",
                ],
            });
            return;
        }

        if (date > currentDate) {
            setMessage({
                ...message,
                errorMessage: [
                    "The end date cannot be in the future. Please select a date that is today or earlier.",
                ],
            });
            return;
        }

        setEndDate(date);
    };

    const handleAddSpellingBeeChallenge = async () => {

        if (!editSpellingBeeChallengeData.id) {
            setAddChallenges(true);
            if (!viewAllChallenges) {
                setLoading((prevLoading) => ({ ...prevLoading, fetchingLoading: true, tableLoading: false, deleteLoading: false, submitLoading: false, viewLoading: false, validationLoading: false }));
                try {
                    await getAllUnitByOffset("0", "10", true, access_token).then((response) => {
                        const { data, statusCode } = response;
                        if (statusCode === 200) {
                            setDropdownList({
                                ...dropdownList,
                                dropdownUnit: data.units.map((unit: any) => ({
                                    id: unit.id,
                                    name: unit.name,
                                }))
                            })
                        } else if (statusCode === 401) {
                            getAuthorizedToken();
                            setMessage({
                                ...message,
                                failureMessage: "Authorization token expired. Try again!"
                            })
                        }

                    })
                } catch (error: any) {
                    if (error.response && error.response.data && typeof error.response.data === "string") {
                        setMessage({
                            ...message,
                            failureMessage: error.response.data.message
                        })
                    } else {
                        setMessage({
                            ...message,
                            failureMessage: "Something went wrong. Please try again"
                        })
                    }
                } finally {
                    setLoading((prevLoading) => ({ ...prevLoading, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, viewLoading: false, validationLoading: false }));
                }

            }
        } else {
            setMessage({
                errorMessage: ["Please save or cancel the challenge before adding new spelling bee challenge."],
                successMessage: "",
                failureMessage: ""
            });
        }

    }


    const viewAllQuestion = useCallback(async (UnitId: string) => {
        setLoading((prevLoading) => ({ ...prevLoading, fetchingLoading: true, tableLoading: false, deleteLoading: false, submitLoading: false, viewLoading: false, validationLoading: false }));
        try {
            setViewAllChallenges(true);
            setFilter({
                status: "",
                dateFilter: "",
                grade: ""
            })
            setActiveFilter({
                status: "",
                grade: { id: "", name: "" }
            })
            setStartDate(null)
            setEndDate(null);
            setSearchText("");
            await getUnitByUnitId(UnitId, access_token).then(async (getUnitResponse) => {
                const { data, statusCode } = getUnitResponse;
                if (statusCode === 200) {
                    setEditSpellingBeeChallengeData({
                        id: "",
                        unit: { id: data.id, name: data.name },
                        grade: { gradeId: data.lesson.grade_id.id, gradeName: data.lesson.grade_id.name },
                        deletedOption: [],
                        deleteS3Path: [],
                        question: "",
                        challengeMedia: {
                            audioFile: { files: "", blobPath: "", fileExtension: "" }
                        },
                        spellingBee: {
                            SpellingBeeText: "",
                            MediaFile: {
                                videoFile: { files: "", blobPath: "", fileExtension: "" }
                            },
                            reward: 0
                        },
                        congratulation: {
                            congratulationId: "",
                            congratulationBadgeIcon: {
                                files: "",
                                blobPath: "",
                                fileExtension: ""

                            },
                            congratulationAudio: {
                                files: "",
                                blobPath: "",
                                fileExtension: ""

                            },
                            congratulationText: "",
                            congratulationCoins: 0,
                            deletedS3Path: []
                        }
                    });

                    const challengeResponse = await GetAllChallenges(data.id, data.lesson.grade_id.id, QuestionCategory.spellingbee, '0', String(itemsPerPage), access_token);
                    if (challengeResponse.statusCode === 200) {
                        handleChallengeData(challengeResponse.data)
                    } else if (statusCode === 401) {
                        getAuthorizedToken();
                        setMessage((prevMessage: MessageDataType) => ({
                            ...prevMessage,
                            failureMessage: 'Authorization token expired. Try again!',
                        }));
                    }
                }

            }).catch((error: any) => {
            })

        } catch (error) {
            console.error('Get All Challenges Error:', error);
        } finally {
            setLoading((prevLoading) => ({ ...prevLoading, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, viewLoading: false, validationLoading: false }));
        }
    }, [])

    const handleDeleteChallenge = useCallback(async (unitId: string) => {
        setShow(true)
        setConfirmationPopupData({
            title: `Are you sure you want to delete?`,
            message: "This action cannot be undone.",
            descriptions: "",
            acceptText: "Yes",
            cancelText: "Cancel",
            onAccept: async () => {
                setShow(false);
                setLoading((prevLoading) => ({ ...prevLoading, fetchingLoading: false, tableLoading: false, deleteLoading: true, submitLoading: false, viewLoading: false, validationLoading: false }));
                try {
                    await DeletAllChallengesByUnitId(unitId, "SPELLINGBEE", access_token).then((getUnitResponse) => {
                        const { data, statusCode } = getUnitResponse;
                        if (statusCode === 200) {
                            setMessage({
                                ...message,
                                successMessage: "All challenges deleted successfully!"
                            })
                        }

                    }).catch((error: any) => {
                        console.error("Error fetching tribe data:", error);
                        if (error.response && error.response.data && typeof error.response.data === "string") {
                            setMessage({
                                ...message,
                                failureMessage: error.response.data.message,
                            });
                        } else {
                            setMessage({
                                ...message,
                                failureMessage: "Something went wrong. Please try again",
                            });
                        }
                    })
                } catch (error: any) {
                    console.error('Get All Challenges Error:', error);
                    if (error.response && error.response.data && typeof error.response.data === "string") {
                        setMessage({
                            ...message,
                            failureMessage: error.response.data.message,
                        });
                    } else {
                        setMessage({
                            ...message,
                            failureMessage: "Something went wrong. Please try again",
                        });
                    }
                } finally {
                    setTimeout(() => {
                        setMessage({
                            ...message,
                            successMessage: "",
                            failureMessage: ""
                        })
                    }, 2500)
                    setLoading((prevLoading) => ({ ...prevLoading, fetchingLoading: false, tableLoading: true, deleteLoading: false, submitLoading: false, viewLoading: false, validationLoading: false }));
                    setCurrentPage(1);
                    getAllChallenges(indexOfFirstItem);
                }


            },
            onCancel: handleClose,
        })


    }, [])


    const handlePreview = (tableSpellingBeeData: TableChallengeDataType) => {
        // Open the child window — must be triggered by a direct user interaction
        const win = window.open(process.env.REACT_APP_REDIRECT_WINDOW, "_blank");

        if (!win) {
            alert("Popup blocked! Please allow popups for this site.");
            return;
        }

        // Add the message listener immediately
        const handleMessage = (event: MessageEvent) => {
            if (event.origin === process.env.REACT_APP_REDIRECT_WINDOW) {
                window.removeEventListener("message", handleMessage); // Clean up
            } else {
                console.warn("Message blocked from unknown origin:", event.origin);
            }
        };

        window.addEventListener("message", handleMessage);

        // Function to send message when the child window is ready
        const sendMessage = () => {
            try {
                if (win && typeof process.env.REACT_APP_REDIRECT_WINDOW === 'string') {
                    win.postMessage({ accessToken: access_token, refreshToken: refresh_token, lessonId: tableSpellingBeeData.lesson.id, unitId: tableSpellingBeeData.unit.id, gradeId: tableSpellingBeeData.grade.gradeId, category: "4", challengeType: "SpellingBee" }, process.env.REACT_APP_REDIRECT_WINDOW);
                } else {
                    console.error("Invalid window reference or redirect window URL is not set");
                }

            } catch (error) {
                console.error("Error sending message:", error);
            }
        };

        // Try sending the message a few times to ensure it reaches
        let tries = 0;
        const interval = setInterval(() => {
            if (win.closed) {
                clearInterval(interval);
                return;
            }

            sendMessage();
            tries++;

            if (tries >= 3) {
                clearInterval(interval);
            }
        }, 1000);
    }


    return (
        <div className="dashboard d-flex">
            <Header />
            <div className="rightContainer">
                <div>
                    {message.successMessage && <SuccessPopup message={message.successMessage} />}
                    {message.failureMessage && <FailurePopup message={message.failureMessage} />}

                    {addChallenges ?
                        <div>
                            <h2 className="page-title text-center">Add Spelling Bee</h2>
                            <div className="pCard" style={{ backgroundColor: "#ffffff" }}>
                                <Form noValidate validated={validated}>
                                    <div className="modal-body" style={{ textAlign: "start" }}>
                                        <div className="d-flex flex-column">

                                            <div>
                                                {!viewAllChallenges && <div className="form-group">
                                                    <h6 className='highlightMediaText'>Unit <span className="text-danger">*</span></h6>
                                                    <select className="form-select" name="challengeUnit" value={editSpellingBeeChallengeData.unit.id} onChange={(e) => handleDropDownData(e.target.value)} required >
                                                        <option value="" disabled>
                                                            Select Unit
                                                        </option>
                                                        {dropdownList.dropdownUnit.length > 0 ? (
                                                            dropdownList.dropdownUnit.map((option: IdAndName) => (
                                                                <option key={option.id} value={option.id}>
                                                                    {option.name}
                                                                </option>
                                                            ))
                                                        ) : (
                                                            <option value="" disabled>
                                                                No Unit added yet
                                                            </option>
                                                        )}
                                                    </select>
                                                </div>}

                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <h5 className='text-center my-3 border-bottom pb-1'>Question</h5>
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <h6 className='highlightMediaText'>Add Spelling Bee Challenge <span className="text-danger">*</span></h6>
                                                    <input type="text" name="question" className="form-control" placeholder="Add Spelling Bee Challenge" value={editSpellingBeeChallengeData.spellingBee.SpellingBeeText} onChange={(e) => handleInputChange(e.target.value, 'spellingBee')} required />
                                                    <div className="invalid-feedback" style={{ textAlign: "center" }}>Please provide a valid question.</div>
                                                </div>

                                                <div className="form-group">
                                                    <h6 className='highlightMediaText'>Reward for the completion of this Spelling Bee Challenge <span className="text-danger">*</span></h6>
                                                    <input type="number" name="reward" className="form-control" placeholder="Reward" value={editSpellingBeeChallengeData.spellingBee.reward} onChange={(e) => handleInputChange(e.target.value, "reward")} onWheel={(e: any) => e.target.blur()} required />
                                                    <div className="invalid-feedback" style={{ textAlign: "center" }}>Please provide a valid reward.</div>
                                                </div>


                                                {!viewAllChallenges && showCongratulationsField && editSpellingBeeChallengeData.unit.id && 
                                                <React.Fragment>
                                                    <div className="row">
                                                    <div className="col-md-12">
                                                        <h5 className='text-center my-3 border-bottom pb-1'>Congratulations Screen</h5>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    
                                                    <div className="col-md-6">
                                                        <h6 className='highlightMediaText'>Congratulations Text <span className="text-danger">*</span></h6>
                                                        <ReactQuill className='whitebg' onChange={(value) => handleCongratsInput(null, "congratulation-text", value, false)} value={editSpellingBeeChallengeData?.congratulation?.congratulationText || ""} style={{ backgroundColor: "#ffffff", borderRadius: "8px", border: "0" }}
                                                            modules={{
                                                                toolbar: [
                                                                    [{ header: [3, 4, false] }],
                                                                    ["bold", "italic", "underline", "blockquote"],
                                                                    [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
                                                                    [{ align: [] }]
                                                                ]
                                                            }}
                                                        />
                                                    </div>

                                                    <div className="col-md-6">
                                                        <h6 className='highlightMediaText'>Congratulations Voice Over <span className="text-danger">*</span></h6>
                                                        {/* Audio Upload/Preview */}
                                                        <div className="customImgUpload">
                                                            <div className="uploadBtn">
                                                                {editSpellingBeeChallengeData.congratulation.congratulationAudio.files ? (
                                                                    <div className="w-100">
                                                                        <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                                            <audio src={editSpellingBeeChallengeData.congratulation.congratulationAudio.blobPath} className="mx-auto" style={{ backgroundColor: "#ffffff", borderRadius: "8px", border: "0" }} controls />
                                                                        </div>
                                                                        {editSpellingBeeChallengeData.congratulation.congratulationAudio.files !== editSpellingBeeChallengeData.congratulation.congratulationAudio.blobPath && (
                                                                            <div className="imgName">{editSpellingBeeChallengeData.congratulation.congratulationAudio.files.name}</div>
                                                                        )}
                                                                    </div>
                                                                ) : (
                                                                    <>
                                                                        <img className="noimage" src="./assets/images/audio-icon.svg" alt="audio-icon" />
                                                                        <label htmlFor="congratulations-audio">
                                                                            Click to upload <span>mp3 or wav <br />(max 20mb)</span>
                                                                        </label>
                                                                        <input type="file" className="form-control d-none" id="congratulations-audio" name="congratulations-audio" accept=".mp3, .wav" onChange={(e) => handleCongratsInput(e, e.target.name, "", true)} required />
                                                                    </>
                                                                )}
                                                            </div>
                                                        </div>

                                                        {/* Replace Audio */}
                                                        {editSpellingBeeChallengeData.congratulation.congratulationAudio.files && (
                                                            <div className="row justify-content-center">
                                                                <div className="col-auto">
                                                                    <button type="button" className="btn btnBorder mb-3 justify-content-start p-0 my-auto" style={{ width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992", fontSize: "14px", fontWeight: "400" }}>
                                                                        <label className='m-0 flex' htmlFor="congratulations-audio" style={{ padding: "6px 12px", cursor: 'pointer' }}>
                                                                            <img src="./assets/images/replace.svg" alt="Replace" style={{ marginRight: "10px" }} />
                                                                            <input type="file" className="form-control d-none" id="congratulations-audio" name="congratulations-audio" accept=".mp3, .wav" onChange={(e) => handleCongratsInput(e, e.target.name, "", true)} required />
                                                                            Replace
                                                                        </label>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>



                                                </div>
                                                </React.Fragment>}


                                            </div>

                                        </div>
                                    </div>
                                </Form>

                                <div className="form-actions">
                                    <div className="row">
                                        <div className="col-md-3"></div>
                                        <div className="col-md-3"></div>

                                        <div className="col-md-3">
                                            <div className="btn-group w-100">
                                                <button type="button" className="btn btn-save btnPurple" onClick={handleSpellingBeeValidation}>Save</button>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <button type="button" className="btn btn-cancel btnBorder" onClick={handleCancel}>Cancel</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        <div>
                            <div className="header-container">
                                <h2 className="page-title text-center">Spelling Bee</h2>

                                {viewAllChallenges && editSpellingBeeChallengeData.unit.name && <div className="breadcrumbBlock">
                                    <ul>
                                        <li>
                                            <a href='./spelling-bee'>Spelling Bee</a> <img src="./assets/images/breadcrumb-arrow.svg" alt="" />
                                        </li>
                                        <li>
                                            {editSpellingBeeChallengeData.unit.name}
                                        </li>
                                    </ul>
                                </div>}
                            </div>
                            <div className="pCard">
                                <div className="topAction align-items-center">
                                    <div className="dropdown statusDrop">
                                        {!viewAllChallenges && <button className="dropdown-toggle" type="button" id="dropdownMenuButtonStatus" data-bs-toggle="dropdown" aria-expanded="false">
                                            {/* {activeFilter.status === "All" ? "Status" : activeFilter.status === "1" ? "Publish" : activeFilter.status === "0" ? "Inactive" : "Status"} */}
                                            Status
                                        </button>}
                                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButtonStatus">
                                            <li><button className={`dropdown-item`} name="status" onClick={() => handleFilter("status", "")}>All</button></li>
                                            <li><button className={`dropdown-item ${activeFilter.status === "1" ? "active" : ""}`} name="status" value="Published" onClick={() => handleFilter("status", "1")} >Published</button></li>
                                            <li><button className={`dropdown-item ${activeFilter.status === "2" ? "active" : ""}`} onClick={() => handleFilter("status", "2")}>Draft</button></li>
                                            <li><button className={`dropdown-item ${activeFilter.status === "0" ? "active" : ""}`} name="status" value="Unpublished" onClick={() => handleFilter("status", "0")} >Unpublished</button></li>
                                        </ul>

                                        {filter.status &&
                                            <span className="badge rounded-pill" style={{ marginLeft: '1rem', background: '#782ACB' }}>{filter.status}
                                                <span className='ps-2' style={{ cursor: 'pointer' }}><img src="./assets/images/xmark-solid.svg" alt="" onClick={() => handleFilter("status", "")} /></span></span>
                                        }

                                        {!viewAllChallenges && <button className="dropdown-toggle" type="button" id="dropdownMenuButtonGrade" data-bs-toggle="dropdown" aria-expanded="false" style={{ paddingLeft: "2rem" }}>
                                            {/* {activeFilter.grade.id ? activeFilter.grade.name : "Grade"} */}
                                            Grade
                                        </button>}
                                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButtonGrade">
                                            <button className={`dropdown-item`} name="grade" value="showAllGrade" onClick={() => handleFilter("grade", { id: "", name: "" })} >
                                                All
                                            </button>
                                            {dropDownList.grade.map((grade: IdAndName, index: number) => (
                                                <li key={grade.id}>
                                                    <button className={`dropdown-item ${activeFilter.grade.id === grade.id ? "active" : ""}`} name="grade" value={grade.name} onClick={() => handleFilter("grade", { id: grade.id, name: grade.name })} >
                                                        {grade.name}
                                                    </button>
                                                </li>
                                            ))}
                                        </ul>



                                        {filter.grade &&
                                            <span className="badge rounded-pill" style={{ marginLeft: '1rem', background: '#782ACB' }}>{filter.grade}
                                                <span className='ps-2' style={{ cursor: 'pointer' }}><img src="./assets/images/xmark-solid.svg" alt="" onClick={() => handleFilter("grade", { id: "", name: "" })} /></span></span>
                                        }


                                        {filter.dateFilter &&
                                            <span className="badge rounded-pill" style={{ marginLeft: '1rem', background: '#782ACB' }}>{filter.dateFilter}
                                                <span className='ps-2' style={{ cursor: 'pointer' }}><img src="./assets/images/xmark-solid.svg" alt="" onClick={() => handleFilter("date", "")} /></span></span>
                                        }
                                    </div>

                                    <div className="dropdown filter ms-auto">
                                        {!viewAllChallenges && <a className="dropdown-toggle" href="#blank" role="button" data-bs-toggle="dropdown" aria-expanded="false" >
                                            <img src="./assets/images/filter.svg" alt="Filter" />
                                        </a>}
                                        <div className="dropdown-menu p-3" onClick={(e) => e.stopPropagation()}>
                                            <div className="mb-3">
                                                {/* <label htmlFor="startDate" className="form-label">
                                                    Start Date
                                                </label> */}
                                                <DatePicker id="startDate" selected={startDate} onChange={(date) => setStartDate(date)} className="form-control" placeholderText="Date From" />
                                            </div>
                                            <div className="mb-3">
                                                {/* <label htmlFor="endDate" className="form-label">
                                                    End Date
                                                </label> */}
                                                <DatePicker id="endDate" selected={endDate} onChange={handleEndDateChange} className="form-control" placeholderText="Date To" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="searchInputDashboard">
                                        {!viewAllChallenges && <input type="text" placeholder="Search" name="searchText" value={searchtext} onChange={(e) => setSearchText(e.target.value)} />}
                                    </div>
                                    <button className="btn add-btn btnPurple w-auto px-3" onClick={handleAddSpellingBeeChallenge}>+</button>
                                </div>

                                {!viewAllChallenges ? (
                                    loading.tableLoading ? (
                                        <div className="d-flex align-items-center mt-5">
                                            <div className="loader mx-auto"></div>
                                        </div>
                                    ) : tableChallengeData.length > 0 ? (
                                        <div className="table-responsive">
                                            <table className="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>UNIT</th>
                                                        <th className="text-center">GRADE</th>
                                                        <th className="text-center">LESSON</th>
                                                        <th className="text-center">SUBJECT</th>
                                                        <th className="text-center">TRIBE</th>
                                                        <th className="text-center">STATUS</th>


                                                        <th className='text-center'>ACTION</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {tableChallengeData.map((tableChallenge: TableChallengeDataType, index: number) => (
                                                        <tr key={index}>
                                                            <td>
                                                                <span data-tooltip-id={`challenge-unit-tooltip-${tableChallenge.id}`} data-tooltip-content={tableChallenge.unit.name} data-tooltip-place="top" >

                                                                    {tableChallenge.unit.name.length > 10 ? tableChallenge.unit.name.substring(0, 10) + "..." : tableChallenge.unit.name}
                                                                </span>
                                                                {tableChallenge.unit.name.length > 10 && <Tooltip id={`challenge-unit-tooltip-${tableChallenge.id}`} />}
                                                            </td>
                                                            <td className="text-center">{tableChallenge.grade.gradeId === "1" ? "Kinder" : tableChallenge.grade.gradeName}</td>
                                                            <td className="text-center">
                                                                <span data-tooltip-id={`challenge-lesson-tooltip-${tableChallenge.id}`} data-tooltip-content={tableChallenge.lesson.name} data-tooltip-place="top" >
                                                                    {tableChallenge.lesson.name.length > 10 ? tableChallenge.lesson.name.substring(0, 10) + "..." : tableChallenge.lesson.name}
                                                                </span>
                                                                {tableChallenge.lesson.name.length > 10 && <Tooltip id={`challenge-lesson-tooltip-${tableChallenge.id}`} />}</td>
                                                            <td className="text-center">
                                                                <span data-tooltip-id={`challenge-subject-tooltip-${tableChallenge.id}`} data-tooltip-content={tableChallenge.subject.name} data-tooltip-place="top" >
                                                                    {tableChallenge.subject.name.length > 10 ? tableChallenge.subject.name.substring(0, 10) + "..." : tableChallenge.subject.name}
                                                                </span>
                                                                {tableChallenge.subject.name.length > 10 && <Tooltip id={`challenge-subject-tooltip-${tableChallenge.id}`} />}
                                                            </td>
                                                            <td className="text-center">
                                                                <span data-tooltip-id={`challenge-tribe-tooltip-${tableChallenge.id}`} data-tooltip-content={tableChallenge.tribe.name} data-tooltip-place="top" >
                                                                    {tableChallenge.tribe.name.length > 10 ? tableChallenge.tribe.name.substring(0, 10) + "..." : tableChallenge.tribe.name}
                                                                </span>
                                                                {tableChallenge.tribe.name.length > 10 && <Tooltip id={`challenge-tribe-tooltip-${tableChallenge.id}`} />}
                                                            </td>
                                                            <td className="text-center">
                                                                <span className={tableChallenge.status === "PUBLISHED" ? "activeStatus" : (tableChallenge.status === "DRAFT" ? "draftStatus" : "inactiveStatus")}>
                                                                    {tableChallenge.status}
                                                                </span>
                                                            </td>
                                                            <td className="text-center">
                                                                <div className="dropdown dots">
                                                                    <button className="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"><img src='./assets/images/more.svg' alt='action button' /></button>
                                                                    <ul className="dropdown-menu">
                                                                        {(tableChallenge.status !== "UNPUBLISHED") && <li>
                                                                            <button className="dropdown-item" onClick={() => {setTableData(tableChallenge);handlePreview(tableChallenge)}}>
                                                                                <img src="assets/images/edit-icon.png" alt="" className="me-2" />
                                                                                Preview
                                                                            </button>
                                                                        </li>}
                                                                        <li>
                                                                            <button className="dropdown-item" onClick={() => {setTableData(tableChallenge);viewAllQuestion(tableChallenge.id)}}>
                                                                                <img src="assets/images/edit-icon.png" alt="" className="me-2" />
                                                                                Edit
                                                                            </button>
                                                                        </li>
                                                                        <li>
                                                                            <button className="dropdown-item" style={{ cursor: 'pointer' }} onClick={() => handleDeleteChallenge(tableChallenge.id)}>
                                                                                <img src="assets/images/delete.png" alt="" className="me-2" />
                                                                                Delete
                                                                            </button>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    ) : (!loading.tableLoading && <p className="text-center mt-5">No Data Found</p>
                                    )
                                ) :

                                <React.Fragment>
                                    {tableData.status !== "UNPUBLISHED" && <div className="p-3">
                                            <button className="btn add-btn btnPurple w-auto px-3" style={{ fontSize: "14px" }} onClick={() => handlePreview(tableData)}>Preview</button>
                                        </div>}
                                    <div className="accordionBox">
                                        <div className="accordion" id="accordionExample">
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="headingThree">
                                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                                        Questions
                                                    </button>
                                                </h2>
                                                <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                                                    <div className="accordion-body">

                                                        {loading.tableLoading ?
                                                            <div className="d-flex align-items-center mt-5">
                                                                <div className="loader mx-auto"></div>
                                                            </div>
                                                            :
                                                            <>
                                                                {(loading.tableLoading || loading.viewLoading) ?
                                                                    <div className="d-flex align-items-center mt-5">
                                                                        <div className="loader mx-auto"></div>
                                                                    </div>
                                                                    :
                                                                    allChallengeData.length > 0 ?
                                                                        allChallengeData.map((challengeData: SpellingBeeDataType, index: number) => (
                                                                            // questionData.type === QuestionType.mcq &&
                                                                            <div className='mb-4' key={challengeData.id} id={challengeData.id}>
                                                                                <div className="unitChallengeLists">
                                                                                    <div className="unitChallengeLists">
                                                                                        <div className='listHead'>
                                                                                            <div className="row mb-2">
                                                                                                {editSpellingBeeChallengeData.id === challengeData.id ? (
                                                                                                    <div className="col-10 form-group">
                                                                                                        <h6 className='highlightmediatext'>Add Spelling Bee Challenge <span className="text-danger">*</span></h6>
                                                                                                        <input type="text" name="question" className="form-control" placeholder="Add Spelling Bee Challenge" value={editSpellingBeeChallengeData.spellingBee.SpellingBeeText} onChange={(e) => handleInputChange(e.target.value, "spellingBee")} required />
                                                                                                    </div>
                                                                                                ) : (
                                                                                                    <div className="col-10">
                                                                                                        <p className="quesText">{indexOfFirstItem + index + 1} - {challengeData.question}</p>
                                                                                                    </div>
                                                                                                )}

                                                                                                {!editSpellingBeeChallengeData.id &&
                                                                                                    <div className="col-2">
                                                                                                        <div className="d-flex justify-content-end">
                                                                                                            <button className="btn" style={{ flexShrink: 0 }} type="button" data-bs-toggle="collapse" data-bs-target={`#challenge-${challengeData.id}`} aria-expanded="false" aria-controls={`challenge-${challengeData.id}`}>
                                                                                                                <img src="./assets/images/chevron-down-M.svg" alt="" />
                                                                                                            </button>


                                                                                                            <div className="dropdown dots">
                                                                                                                <button className="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false" >
                                                                                                                    <img src='./assets/images/more.svg' alt='action button' />
                                                                                                                </button>
                                                                                                                <ul className="dropdown-menu">

                                                                                                                    <li>
                                                                                                                        <button className="dropdown-item" onClick={() => handleEditChallenges(challengeData)} >
                                                                                                                            <img src="./assets/images/edit-icon.png" alt="" className="me-2" />
                                                                                                                            Edit
                                                                                                                        </button>
                                                                                                                    </li>
                                                                                                                    <li>
                                                                                                                        <button className="dropdown-item" style={{ cursor: 'pointer' }} onClick={() => handleDeleteChallengeById(challengeData.id)}>
                                                                                                                            <img src="./assets/images/delete.png" alt="" className="me-2" />
                                                                                                                            Delete
                                                                                                                        </button>
                                                                                                                    </li>
                                                                                                                </ul>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>}
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>

                                                                                    <div className={challengeData.id === editSpellingBeeChallengeData.id ? "collapse show" : "collapse"} id={`challenge-${challengeData.id}`}>
                                                                                        <div className="card card-body bg-transparent" style={{ border: 0 }}>
                                                                                            {challengeData.id !== editSpellingBeeChallengeData.id &&
                                                                                                <>

                                                                                                    <div className="row">
                                                                                                        <div className="col-md-6">
                                                                                                            <div className="form-group">
                                                                                                                <h6 className='highlightMediaText'>Reward for the completion of this Spelling Bee Challenge</h6>
                                                                                                                <input type="number" name="reward" className="form-control" placeholder="Reward" value={challengeData.spellingBee.reward} readOnly />
                                                                                                            </div>
                                                                                                        </div>
                                                                                                        {/* {challengeData.spellingBee.MediaFile.videoFile.files &&
                                                                                                        <div className="col-md-6">
                                                                                                            <div className="form-group">
                                                                                                                <h6 classname='highlightmediatext'>Spelling Bee Intro Video File <span className="text-danger">*</span></h6>
                                                                                                                <div className="customImgUpload">
                                                                                                                    <div className="uploadBtn">
                                                                                                                        <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                                                                                            <video controls style={{ objectFit: "contain", width: "100%", maxWidth: "10vw", maxHeight: "10vh", margin: "0 auto" }}>
                                                                                                                                <source src={challengeData.spellingBee.MediaFile.videoFile.blobPath} type="video/mp4" />
                                                                                                                                Your browser does not support the video tag.
                                                                                                                            </video>
                                                                                                                            {challengeData.id === editSpellingBeeChallengeData.id &&
                                                                                                                                <button type="button" className="bg-transparent" >
                                                                                                                                    <img src="./assets/images/delete.svg" alt="Delete" width="24" />
                                                                                                                                </button>
                                                                                                                            }

                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    } */}
                                                                                                        {/* {challengeData.challengeMedia.audioFile.files &&
                                                                                                            <div className="col-md-6">
                                                                                                                <div className="form-group">
                                                                                                                    <h6 className='highlightmediatext'>Voice Over Audio</h6>
                                                                                                                    <div className="customImgUpload">
                                                                                                                        <div className="uploadBtn">
                                                                                                                            <div className="w-100">
                                                                                                                                <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                                                                                                    <audio src={challengeData.challengeMedia.audioFile.blobPath} className="mx-auto" controls />

                                                                                                                                </div>
                                                                                                                            </div>
                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </div>} */}

                                                                                                    </div>
                                                                                                </>
                                                                                            }



                                                                                            {(challengeData.id === editSpellingBeeChallengeData.id) && (
                                                                                                <>

                                                                                                    <div className="row">
                                                                                                        <div className="col-md-6">
                                                                                                            <div className="form-group">
                                                                                                                <h6 className='highlightMediaText'>Reward for the completion of this Spelling Bee Challenge <span className="text-danger">*</span></h6>
                                                                                                                <input type="number" name="reward" className="form-control" placeholder="Reward" value={editSpellingBeeChallengeData.spellingBee.reward} onChange={(e) => handleInputChange(e.target.value, "reward")} onWheel={(e: any) => e.target.blur()} required />
                                                                                                            </div>
                                                                                                        </div>
                                                                                                        {/* <div className="col-md-6">
                                                                                                        <div className="form-group">
                                                                                                            <h6 classname='highlightmediatext'>Spelling Bee Intro Video File <span className="text-danger">*</span></h6>
                                                                                                            <div className="customImgUpload">
                                                                                                                <div className="uploadBtn">
                                                                                                                    {editSpellingBeeChallengeData.spellingBee.MediaFile.videoFile.files ? (
                                                                                                                        <div className="w-100">
                                                                                                                            <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                                                                                                <video controls style={{ objectFit: "contain", width: "100%", maxWidth: "10vw", maxHeight: "10vh", margin: "0 auto" }} >
                                                                                                                                    <source src={editSpellingBeeChallengeData.spellingBee.MediaFile.videoFile.blobPath} type="video/mp4" />
                                                                                                                                    Your browser does not support the video tag.
                                                                                                                                </video>
                                                                                                                                
                                                                                                                            </div>

                                                                                                                        </div>
                                                                                                                    ) : (
                                                                                                                        <>
                                                                                                                            <img className="noimage" src="./../assets/images/no-image-icon.png" alt="" />
                                                                                                                            <label htmlFor={`videoFile`}>Click to upload<span>Video</span></h6>
                                                                                                                            <input type="file" className="form-control d-none" name={`videoFile`} id={`videoFile`} accept=".mp4, .webm" onChange={(e) => handleChallengeMedia(e, "add", "videoFile")} required />
                                                                                                                        </>
                                                                                                                    )}
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                        {editSpellingBeeChallengeData.spellingBee.MediaFile.videoFile.files && <div className="row justify-content-center">
                                                                                                            <div className="col-auto">
                                                                                                                <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={() => handleChallengeMedia("", "delete", "videoFile")}>
                                                                                                                    <img src="./assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                                                                                                </button>
                                                                                                            </div>
                                                                                                        </div>}
                                                                                                    </div> */}
                                                                                                        {/* <div className="col-md-6">
                                                                                                            <div className="form-group">
                                                                                                                <h6 className='highlightmediatext'>Voice Over Audio</h6>
                                                                                                                <div className="customImgUpload">
                                                                                                                    <div className="uploadBtn">
                                                                                                                        {editSpellingBeeChallengeData.challengeMedia.audioFile.files ?
                                                                                                                            <div className="w-100">
                                                                                                                                <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                                                                                                    <audio src={editSpellingBeeChallengeData.challengeMedia.audioFile.blobPath} className="mx-auto" controls />

                                                                                                                                </div>
                                                                                                                                {editSpellingBeeChallengeData.challengeMedia.audioFile.files !== editSpellingBeeChallengeData.challengeMedia.audioFile.blobPath &&
                                                                                                                                    <div className="imgName">
                                                                                                                                        {editSpellingBeeChallengeData.challengeMedia.audioFile.files.name}
                                                                                                                                    </div>
                                                                                                                                }
                                                                                                                            </div>
                                                                                                                            :
                                                                                                                            <>
                                                                                                                                <img className="noimage" src="./assets/images/audio-icon.svg" alt="audio-icon" />
                                                                                                                                <label htmlFor="audioFile">Click to upload <span>mp3 or wav <br />(max 20mb)</span></label>
                                                                                                                                <input type="file" className="form-control d-none" id="audioFile" name="audioFile" accept=".mp3, .wav" onChange={(e) => handleChallengeMedia(e, "add", "audioFile")} />
                                                                                                                            </>
                                                                                                                        }
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                            {editSpellingBeeChallengeData.challengeMedia.audioFile.files && <div className="row justify-content-center">
                                                                                                                <div className="col-auto">
                                                                                                                    <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={(e) => handleChallengeMedia(e, "delete", "audioFile")}>
                                                                                                                        <img src="./assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                                                                                                    </button>
                                                                                                                </div>
                                                                                                            </div>}
                                                                                                        </div> */}
                                                                                                    </div>
                                                                                                </>
                                                                                            )}



                                                                                            {editSpellingBeeChallengeData.id === challengeData.id &&
                                                                                                <div className="row justify-content-center" style={{ padding: "25px 0" }}>
                                                                                                    <div className="col-md-3">
                                                                                                        <div className="btn-group w-100">
                                                                                                            <button type="button" className="btn btn-save btnPurple" onClick={handleSpellingBeeValidation}>Save</button>

                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="col-md-3">
                                                                                                        <button type="button" className="btn btn-cancel btnBorder" onClick={handleCancel}>Cancel</button>
                                                                                                    </div>
                                                                                                </div>}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>

                                                                            </div>
                                                                        )) :
                                                                        (!loading.tableLoading && !loading.viewLoading && <p className="text-center mt-5">No Data Found</p>)
                                                                }

                                                            </>
                                                        }
                                                    </div>
                                                    <div className="pagination-container">
                                                        <nav className="d-flex justify-content-between">
                                                            <div className="page-length">
                                                                Showing {Math.min(indexOfFirstItem + 1, challengeCount)} - {Math.min(indexOfLastItem, challengeCount)} of {challengeCount}
                                                            </div>
                                                            <ul className="pagination justify-content-center mx-auto">
                                                                <li className="page-item">
                                                                    <button className="page-link" aria-label="Previous" onClick={() => handlePagination(currentPage - 1, 'left')}>
                                                                        <span aria-hidden="true"><img src="./assets/images/arrow-left-small.svg" alt="" /></span>
                                                                    </button>
                                                                </li>
                                                                <li className="page-item disabled">
                                                                    <span className="page-link">
                                                                        {indexOfFirstItem + 1} of {indexOfLastItem}
                                                                    </span>
                                                                </li>
                                                                <li className="page-item">
                                                                    <button className="page-link" aria-label="Next" onClick={() => handlePagination(currentPage + 1, 'right')}>
                                                                        <span aria-hidden="true"><img src="./assets/images/arrow-right-small.svg" alt="" /></span>
                                                                    </button>
                                                                </li>
                                                            </ul>
                                                        </nav>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id={`headingFour`}>
                                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#collapseFour`} aria-expanded="false" aria-controls={`collapseFour`}>
                                                        Congratulations Screen
                                                    </button>
                                                </h2>
                                                <div id={`collapseFour`} className="accordion-collapse collapse" aria-labelledby={`headingFour`} data-bs-parent="#accordionExample">
                                                    <div className="accordion-body">
                                                        <div className="form-group">
                                                            <div className="row">

                                                                <div className="col-md-6">
                                                                    <h6 className='highlightMediaText'>Congratulations Text <span className="text-danger">*</span></h6>
                                                                    <ReactQuill className='whitebg' onChange={(value) => handleCongratsInput(null, "congratulation-text", value, false)} value={editSpellingBeeChallengeData?.congratulation?.congratulationText || ""} style={{ backgroundColor: "#ffffff", borderRadius: "8px", border: "0" }}
                                                                        modules={{
                                                                            toolbar: [
                                                                                [{ header: [3, 4, false] }],
                                                                                ["bold", "italic", "underline", "blockquote"],
                                                                                [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
                                                                                [{ align: [] }]
                                                                            ]
                                                                        }}
                                                                    />
                                                                </div>

                                                                <div className="col-md-6">
                                                                    <h6 className='highlightMediaText'>Congratulations Voice Over <span className="text-danger">*</span></h6>
                                                                    {/* Audio Upload/Preview */}
                                                                    <div className="customImgUpload whitebg mb-3">
                                                                        <div className="uploadBtn">
                                                                            {editSpellingBeeChallengeData.congratulation.congratulationAudio.files ? (
                                                                                <div className="w-100">
                                                                                    <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                                                        <audio src={editSpellingBeeChallengeData.congratulation.congratulationAudio.blobPath} className="mx-auto" style={{ backgroundColor: "#ffffff", borderRadius: "8px", border: "0" }} controls />
                                                                                    </div>
                                                                                    {editSpellingBeeChallengeData.congratulation.congratulationAudio.files !== editSpellingBeeChallengeData.congratulation.congratulationAudio.blobPath && (
                                                                                        <div className="imgName">{editSpellingBeeChallengeData.congratulation.congratulationAudio.files.name}</div>
                                                                                    )}
                                                                                </div>
                                                                            ) : (
                                                                                <>
                                                                                    <img className="noimage" src="./assets/images/audio-icon.svg" alt="audio-icon" />
                                                                                    <label htmlFor="congratulations-audio">
                                                                                        Click to upload <span>mp3 or wav <br />(max 20mb)</span>
                                                                                    </label>
                                                                                    <input type="file" className="form-control d-none" id="congratulations-audio" name="congratulations-audio" accept=".mp3, .wav" onChange={(e) => handleCongratsInput(e, e.target.name, "", true)} required />
                                                                                </>
                                                                            )}
                                                                        </div>
                                                                    </div>

                                                                    {/* Replace Audio */}
                                                                    {editSpellingBeeChallengeData.congratulation.congratulationAudio.files && (
                                                                        <div className="row justify-content-center">
                                                                            <div className="col-auto">
                                                                                <button type="button" className="btn btnBorder mb-3 justify-content-start p-0 my-auto" style={{ width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992", fontSize: "14px", fontWeight: "400" }}>
                                                                                    <label className='m-0 flex' htmlFor="congratulations-audio" style={{ padding: "6px 12px", cursor: 'pointer' }}>
                                                                                        <img src="./assets/images/replace.svg" alt="Replace" style={{ marginRight: "10px" }} />
                                                                                        <input type="file" className="form-control d-none" id="congratulations-audio" name="congratulations-audio" accept=".mp3, .wav" onChange={(e) => handleCongratsInput(e, e.target.name, "", true)} required />
                                                                                        Replace
                                                                                    </label>
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </div>



                                                            </div>

                                                        </div>
                                                        <div className="d-flex justify-content-end mt-3 mb-3">
                                                            <button type="button" className="btn btn-save btnPurple" style={{ width: '250px' }} onClick={validateCongratsData}>Save</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
</React.Fragment>
                                }


                            </div>
                        </div>
                    }

                </div>
            </div>

            {loading.deleteLoading &&  // Show loader when loading is true
                <Loader message="Loading, Deleting Data..." />
            }
            {loading.fetchingLoading &&  // Show loader when loading is true
                <Loader message="Loading, Fetching Data..." />
            }
            {loading.submitLoading &&  // Show loader when loading is true
                <Loader message="Loading, Submitting Data..." />
            }

            {show &&
                <ConfirmationPopup
                    title={confirmationPopupData.title}
                    message={confirmationPopupData.message}
                    isBackIterated={true}
                    descriptions={confirmationPopupData.descriptions}
                    acceptText={confirmationPopupData.acceptText}
                    cancelText={confirmationPopupData.cancelText}
                    onAccept={confirmationPopupData.onAccept}
                    onCancel={confirmationPopupData.onCancel}
                    onCrossClick={confirmationPopupData.onCancel}
                />
            }

            {previewSource && (
                <div className="modal-backdrop" style={{ zIndex: '1200' }}>
                    <div className="modal-content">
                        <div className="modal-header justify-content-end">
                            <button className="p-2" onClick={handleClosePreview}>
                                <img src="./assets/images/cross-s.png" alt="" />
                            </button>
                        </div>
                        <div className='overflow-auto'>
                            <div className='modal-body mx-auto' style={{ maxWidth: '1000px', maxHeight: '1000px' }}>
                                {previewSourceType === "json" ?
                                    <LottieAnimation animationPath={previewSource} isFullscreen={isAnimationFullscreen} />
                                    :
                                    <div style={{ height: '200px', width: '200px', margin: '0 auto' }}>
                                        <img src={previewSource} alt="Preview" className="img-fluid" style={{ objectFit: "contain", height: "100%", width: "100%" }} />
                                    </div>
                                }

                            </div>
                        </div>
                    </div>
                </div>
            )}
            {message.errorMessage.length > 0 &&
                <CustomAlert
                    errorCount={message.errorMessage.length}
                    messages={message.errorMessage}
                    onClose={() => { setMessage({ ...message, errorMessage: [] }); setValidated(false) }}
                />
            }
        </div>
    );
};

export default SpellingBee  